import DialogIconMessage from './DialogIconMessage';

export default DialogIconMessage;
